import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';
import DriverWageDetails from './driver-wage-details.jsx';

export default class DriverWageAccount extends React.Component {
  constructor(props) {
    super(props);
    localStorage.setItem("currentMonthNumber", moment().month()+1);
    localStorage.setItem("currentMonthYear", moment().year());
    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || null,
      isLoading: true,
      //currentMonthNumber: moment().month()+1,
      //currentMonthYear: moment().year(),
      viewJustOneDriver: props.viewJustOneDriver || null,
      url: props.url || null,
    };

    this.setCurrentMonth.bind(this);
    this.getDriverWagesForMonth = this.getDriverWagesForMonth.bind(this);
  }

  componentDidMount() {
    this.getDriverWageAccount();
    this.getDriverWagesForMonth(localStorage.getItem("currentMonthNumber"), localStorage.getItem("currentMonthYear"));
  }

  getDriverWageAccount() {
    if ((this.state.isLoading !== null)
      && (this.state.viewJustOneDriver !== null)) {
      return fetch(this.props.url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer '+window.api_token
          ,"Accept": 'application/json'
        },
      }).
      then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            data: driverJson,
            isLoading: false
          })
        });
      });
    }
    else {
      this.setState({isLoading: false});
    }
  }

  getDriverWagesForMonth(monthNumber, monthYear) {
    let that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/wage-accounts/'+
            this.state.data.driver_wage_account_id+'/get-wages-for/'+
            monthNumber+'/'+monthYear,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driverWagesJson) {
      that.setState({
        driver_wages: driverWagesJson,
        isLoading: false,
      });
    });
  }

  setCurrentMonth(monthNumber, monthYear) {
    //this.getDriverWagesForMonth(monthNumber, monthYear);
    //this.setState({
      //currentMonthNumber: monthNumber,
      //currentMonthYear: monthYear,
    //});
    localStorage.setItem("currentMonthNumber",monthNumber);
    localStorage.setItem("currentMonthYear",monthYear);
    this.getDriverWagesForMonth(localStorage.getItem("currentMonthNumber"), localStorage.getItem("currentMonthYear"));
    //if (this.state.expanded) {
      $(".new_invoice").trigger('click');
      $(".driver-expanded-wages-list").slideToggle(200);
    //}
  }

  handleButtonClicked(variable) {
    $("#driver-expanded-wages-list-"+variable).slideToggle(200);
    this.setState({expanded: !this.state.expanded});
    this.getDriverWagesForMonth(localStorage.getItem("currentMonthNumber"), localStorage.getItem("currentMonthYear"));
  }

  handleWageDetailsButtonClicked(wage, title,fromDate,toDate) {
    console.log(wage);
    console.log(title);
    console.log(fromDate);
    console.log(toDate);
    let driverName = this.state.data.first_name+' '+this.state.data.last_name;
    $('#driver-wage-details-modal').data('wage-id', wage.id);
    $('#driver-wage-details-modal').data('title', title);
    $('#driver-wage-details-modal').data('name', driverName);
    $('#driver-wage-details-modal').modal('show');
    if (document.getElementById(
      'react-component-g4-logistics-portal-driver-wage-details')) {
    $('#driver-wage-details-modal span.modal-title-driver-wage-details').html(title);
    $('#driver-wage-details-modal span.modal-title-driver-name').html(driverName);
      ReactDOM.unmountComponentAtNode(document.getElementById(
        'react-component-g4-logistics-portal-driver-wage-details'));
      ReactDOM.render(<DriverWageDetails data={wage} title={title} fromDate={fromDate} toDate={toDate} getDriverWagesForMonth={this.getDriverWagesForMonth}/>,
        document.getElementById(
          'react-component-g4-logistics-portal-driver-wage-details'));
    }
  }

  setCardClass(cardIndex) {
    let redOrGreen = "";
    const driverWages = this.state.driver_wages && this.state.driver_wages[cardIndex];
    if (driverWages) {
      const { driver_approved, driver_not_approved_reason, accountant_approved, wage_paid, wage_paid_reference } = driverWages;
      if (driver_approved === 0 && driver_not_approved_reason !== null) {
        redOrGreen = "wage-all-unapproved";
      } else if (accountant_approved === 0 && driver_approved === 1 && wage_paid === 0) {
        redOrGreen = "wage-all-accountant_unapproved-driver_approved-and-not-paid";
      } else if (accountant_approved === 1 && driver_approved === 0) {
        redOrGreen = "wage-all-accountant-approved";
      } else if (accountant_approved === 1 && driver_approved === 1 && wage_paid === 0) {
        redOrGreen = "wage-all-approved-and-not-paid";
      } else if (wage_paid || driver_approved === 1) {
        redOrGreen = wage_paid_reference && wage_paid_reference.includes('Bank Ref') ? "wage-all-approved-and-paid-complete-turnblue" : "wage-all-approved-and-paid-complete";
      }
    }
    return redOrGreen;
  }

  render() {
    let currentMonthNumber = localStorage.getItem("currentMonthNumber");
    let currentYear = localStorage.getItem("currentMonthYear");
    //let currentMonthNumber = this.state.currentMonthNumber;
    //let currentYear = this.state.currentMonthYear;

    let currentMonthName = moment(currentMonthNumber, 'MM').format('MMMM');

    let previousYear = parseInt(currentYear) - 1;
    let nextYear = parseInt(currentYear) + 1;
    let previousMonthYear = previousYear;
    let previousMonthNumber = parseInt(currentMonthNumber) - 1;
    let nextMonthNumber = parseInt(currentMonthNumber) + 1;
    let nextMonthYear = currentYear;

    if (currentMonthNumber > 1) {
      previousMonthNumber = parseInt(currentMonthNumber) - 1;
      previousMonthYear = currentYear;
    }
    else {
      previousMonthNumber = 12;
      previousMonthYear = previousYear;
    }

    if (currentMonthNumber < 12) {
      nextMonthNumber = parseInt(currentMonthNumber) + 1;
      nextMonthYear = currentYear;
    }
    else {
      nextMonthNumber = 1;
      nextMonthYear = nextYear;
    }

    let previousMonthName = moment(previousMonthNumber, 'MM').format('MMMM');
    let nextMonthName = moment(nextMonthNumber, 'MM').format('MMMM');
    let weekno1 = "Week 1";
    let weekno2 = "Week 2";
    let weekno3 = "Week 3";
    let weekno4 = "Week 4";
    let weekno5 = "Week 5";
    let actual = moment();
    if(this.state.driver_wages){
      //let start0 = moment(this.state.driver_wages[0].all_week_days[0].monday);
      //let end0 = moment(this.state.driver_wages[0].all_week_days[0].sunday);
      //if (moment(actual).isBetween(start0, end0)) {
      //}

      weekno1 = (this.state.driver_wages[0].all_week_days[0]) ? moment(this.state.driver_wages[0].all_week_days[0].monday).format('DD-MM-Y')+' - '+moment(this.state.driver_wages[0].all_week_days[0].sunday).format('DD-MM-Y'): weekno1;
      weekno2 = (this.state.driver_wages[0].all_week_days[1]) ? moment(this.state.driver_wages[0].all_week_days[1].monday).format('DD-MM-Y')+' - '+moment(this.state.driver_wages[0].all_week_days[1].sunday).format('DD-MM-Y'): weekno2;
      weekno3 = (this.state.driver_wages[0].all_week_days[2]) ? moment(this.state.driver_wages[0].all_week_days[2].monday).format('DD-MM-Y')+' - '+moment(this.state.driver_wages[0].all_week_days[2].sunday).format('DD-MM-Y'): weekno3;
      weekno4 = (this.state.driver_wages[0].all_week_days[3]) ? moment(this.state.driver_wages[0].all_week_days[3].monday).format('DD-MM-Y')+' - '+moment(this.state.driver_wages[0].all_week_days[3].sunday).format('DD-MM-Y'): weekno4;
      weekno5 = (this.state.driver_wages[0].all_week_days[4]) ? moment(this.state.driver_wages[0].all_week_days[4].monday).format('DD-MM-Y')+' - '+moment(this.state.driver_wages[0].all_week_days[4].sunday).format('DD-MM-Y'): weekno5;
    }    

    let titleForWeek1 = currentMonthName+' '+currentYear+' '+weekno1;
    let titleForWeek2 = currentMonthName+' '+currentYear+' '+weekno2;
    let titleForWeek3 = currentMonthName+' '+currentYear+' '+weekno3;
    let titleForWeek4 = currentMonthName+' '+currentYear+' '+weekno4;
    let titleForWeek5 = currentMonthName+' '+currentYear+' '+weekno5;
    
    return(
      <div  
       id={"driver-wage-account-"+this.state.data.id}
      className={"driver-wage-account-container"+
      (this.state.expanded ? ' wage-container-expanded ' : '')}>

        <div
          className="row"
          onDoubleClick={
            (e) => {
              this.handleButtonClicked(this.state.data.id)
            }
          }
        >
          <div className="col-md-1 text-left">
            <img
              src={"/user-images/"+this.state.data.id}
              className="driver-excesses-table-driver-image"
            />
          </div>

          <div className="col-md-4">
            <h3>
              <a href={"/portal-admin/users/view/"+this.state.data.id}>
                {this.state.data.first_name} {this.state.data.last_name}
              </a>
            </h3>
          </div>

          <div className="col-md-2">
            <h3>
            {(this.state.data.account_holiday_status == 'not_on_holiday') ? 'NOT ON HOLD' : 'ON HOLD'}
            </h3>
          </div>

          <div className="col-md-2">
            {(this.state.data.is_driver_sick == '0') ? '' : <h3><span className="badge badge-pill badge-info">SICK</span></h3>}
            {(this.state.data.is_driver_do_not_pay == '0') ? '' : <h3><span className="badge badge-pill badge-warning">DO NOT PAY</span></h3>}
          </div>

          <div className="col-md-1">
            <h3>
            #
            </h3>
          </div>

          <div className="col-md-2 text-right">
            <button
              onClick={(e) => {this.handleButtonClicked(this.state.data.id)}}
              className="btn btn-lg btn-default new_invoice">
              Invoices {(this.state.expanded ?
                <i className="fa fa-minus"></i>:
                <i className="fa fa-level-down-alt"></i>)}
            </button>
          </div>
        </div>


    {(this.state.driver_wages) ?
  <div
    className="driver-expanded-wages-list"
    id={"driver-expanded-wages-list-"+this.state.data.id}>
    <div className="row text-center">

        <div className="col-md-4">
          <a
            href="#"
            className="btn btn-lg btn-primary"
            onClick={(e) => {
              e.preventDefault();
              this.setCurrentMonth(
                previousMonthNumber,
                previousMonthYear
              )}
            }><i className="fas fa-arrow-left">
            </i> <i className="fas fa-calendar-alt">
            </i> {previousMonthName} {previousMonthYear}
          </a>
        </div>
        <div className="col-md-4">
          <a
            href=""
            onClick={(e) => {
              e.preventDefault();
            }}
            className="btn btn-lg btn-success">
            <i className="fas fa-calendar-alt">
            </i> {currentMonthName} {currentYear}
             </a>
        </div>
        <div className="col-md-4">
          <a
            href="#"
            className="btn btn-lg btn-primary"
            onClick={(e) => {
              e.preventDefault();
              this.setCurrentMonth(
                nextMonthNumber,
                nextMonthYear
              )}
            }>
            <i className="fas fa-calendar-alt">
          </i> {nextMonthName} {nextMonthYear} <i
          className="fas fa-arrow-right"></i>
          </a>
        </div>
        </div>

        <div className="row driver-wage-month-calendar-week-container">
          <div className="col text-center">
            <div className={this.setCardClass(0)}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[0].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[0].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{/*(this.state.driver_wages[0].wage_total_payable_in_pence < 0) ? '0.00' : 
                    (this.state.driver_wages[0].
                      wage_total_payable_in_pence/100).
                    toFixed(2)*/}
                  {(this.state.driver_wages[0].wage_total_payable_in_pence/100).toFixed(2)}
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[0].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[0].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[0].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[0],
                      titleForWeek1,
                      this.state.driver_wages[0].all_week_days[0].monday,
                      this.state.driver_wages[0].all_week_days[0].sunday
                    )
                  }}>
                <i className="fa fa-pound-sign"></i> Invoice Details
              </button>
              <div className="week-title">
                {titleForWeek1}
              </div>
            </div>
          </div>
          <div className="col text-center">
            <div className={this.setCardClass(1)}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[1].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[1].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{/*(this.state.driver_wages[1].wage_total_payable_in_pence < 0) ? '0.00' : 
                    (this.state.driver_wages[1].
                      wage_total_payable_in_pence/100).
                    toFixed(2)*/}
                  {(this.state.driver_wages[1].wage_total_payable_in_pence/100). toFixed(2)}
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[1].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[1].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[1].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                  this.handleWageDetailsButtonClicked(
                    this.state.driver_wages[1],
                    titleForWeek2,
                    this.state.driver_wages[0].all_week_days[1].monday,
                    this.state.driver_wages[0].all_week_days[1].sunday
                  )
                }}>
                <i className="fa fa-pound-sign"></i> Invoice Details
              </button>
            <div className="week-title">
                {titleForWeek2}
            </div>
          </div>
          </div>
          <div className="col text-center">
            <div className={this.setCardClass(2)}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[2].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[2].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{/*(this.state.driver_wages[2].wage_total_payable_in_pence < 0) ? '0.00' :                     
                    (this.state.driver_wages[2].wage_total_payable_in_pence/100).toFixed(2)*/}

                  {(this.state.driver_wages[2].wage_total_payable_in_pence/100).toFixed(2)}
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[2].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[2].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[2].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[2],
                      titleForWeek3,
                      this.state.driver_wages[0].all_week_days[2].monday,
                      this.state.driver_wages[0].all_week_days[2].sunday
                    )
                  }}>
                <i className="fa fa-pound-sign"></i> Invoice Details
              </button>
              <div className="week-title">
                {titleForWeek3}
              </div>
            </div>
          </div>
          <div className="col text-center">
            <div className={this.setCardClass(3)}>
                <div className="row status-container">
                  <div className="col-md-3 wage-amount-container">
                  {
                    ((this.state.driver_wages[3].wage_total_payable_in_pence === 0) &&
                    (this.state.driver_wages[3].accountant_approved === 0)) ?
                      <i className="fa fa-question"></i>
                    :
                    <span>
                      &pound;{/*(this.state.driver_wages[3].wage_total_payable_in_pence < 0) ? '0.00' : 
                        (this.state.driver_wages[3].wage_total_payable_in_pence/100
                    ).toFixed(2)*/}
                  {(this.state.driver_wages[3].wage_total_payable_in_pence/100).toFixed(2)}
                    </span>
                  }
                  </div>
                  <div className="col-md-3 accountant-approved-container">
                  {
                    (this.state.driver_wages[3].accountant_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 driver-approved-container">
                  {
                    (this.state.driver_wages[3].driver_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 wage-paid-container">
                  {
                    (this.state.driver_wages[3].wage_paid === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[3],
                      titleForWeek4,
                      this.state.driver_wages[0].all_week_days[3].monday,
                      this.state.driver_wages[0].all_week_days[3].sunday
                    )
                  }}
                  >
                <i className="fa fa-pound-sign"></i> Invoice Details
              </button>
              <div className="week-title">
                {titleForWeek4}
              </div>
            </div>
          </div>
        {(this.state.driver_wages && this.state.driver_wages[4]) ?
          <div className="col text-center">
            <div className={this.setCardClass(4)}>
                <div className="row status-container">
                  <div className="col-md-3 wage-amount-container">
                  {
                    ((this.state.driver_wages[4].wage_total_payable_in_pence === 0) &&
                    (this.state.driver_wages[4].accountant_approved === 0)) ?
                      <i className="fa fa-question"></i>
                    :
                    <span>
                      &pound;{/*(this.state.driver_wages[4].wage_total_payable_in_pence < 0) ? '0.00' : 
                        (this.state.driver_wages[4].wage_total_payable_in_pence/100
                    ).toFixed(2)*/}
                  {(this.state.driver_wages[4].wage_total_payable_in_pence/100).toFixed(2)}
                    </span>
                  }
                  </div>
                  <div className="col-md-3 accountant-approved-container">
                  {
                    (this.state.driver_wages[4].accountant_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 driver-approved-container">
                  {
                    (this.state.driver_wages[4].driver_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 wage-paid-container">
                  {
                    (this.state.driver_wages[4].wage_paid === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[4],
                      titleForWeek5,
                      this.state.driver_wages[0].all_week_days[4].monday,
                      this.state.driver_wages[0].all_week_days[4].sunday
                    )
                  }}
                  >
                <i className="fa fa-pound-sign"></i> Invoice Details
              </button>
              <div className="week-title">
                {titleForWeek5}
              </div>
            </div>
          </div>  
        : null}
        </div>
          </div>: ''}
      </div>
    );
  }
}
